import { createFileRoute, notFound } from '@tanstack/react-router';

import { patternsSearch } from './-patterns-search';
import { lazyScreen } from '@/shared/screen';

// Padrões da onda 0 só em dev (portão E5): em produção a rota responde 404 e o chunk nem é pedido.
export const Route = createFileRoute('/dev/patterns')({
  validateSearch: patternsSearch,
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-patterns-catalog'), 'PatternsCatalog') : () => null,
});
